module.exports = __webpack_public_path__ + "static/media/alarm.dde7e282.mp3";